import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { AuthOrderDTO, AuthOrderResponseDTO, TagModelDTO } from '../types';

export const scannerApi = new BaseApi({
  baseURL: `${ROUTER_API}/api/v2`,
  tokenKey: 'token',
  timeout: 30000,
});

export const scannerProvider = new BaseApi({
  baseURL: `${ROUTER_API}/providers/core/v1`,
  tokenKey: 'token',
  timeout: 30000,
});

export const getTagInformationApi = async (tagId: string) => {
  const url = `/tags/uid/${tagId}`;
  const { data } = await scannerApi.api.get<TagModelDTO>(url);
  return data;
};

export const saveOrderApi = async (payload: AuthOrderDTO) => {
  const url = '/auth/order';
  const { data } = await scannerProvider.api.post<AuthOrderResponseDTO>(url, payload);
  return data;
};
